import { sanitizeHtml } from '../../utils/sanitizeHtml';

/**
 * Converte o HTML completo de public/data/termos_privacidade.html (devolvido
 * pela API company/terms/get.php) em conteúdo para renderizar direto na página.
 *
 * - remove o título, a linha de versão e o rodapé do arquivo (a página tem os seus);
 * - garante um id em cada <h2> para o índice lateral;
 * - monta o índice agrupado pelas partes (<h2 class="part">).
 *
 * @param {string} rawHtml
 * @returns {{ html: string, version: string, toc: Array<{id: string, title: string, sections: Array<{id: string, title: string}>}> }}
 */
export function parseTermsDocument(rawHtml) {
  const doc = new DOMParser().parseFromString(rawHtml || '', 'text/html');
  const root = doc.querySelector('.container') || doc.body;

  const versionEl = root.querySelector('.version');
  const version = versionEl ? versionEl.textContent.trim() : '';

  root.querySelectorAll('h1, .version, .footer').forEach((el) => el.remove());

  const toc = [];
  let sectionIndex = 0;

  root.querySelectorAll('h2').forEach((heading) => {
    const title = heading.textContent.trim();

    if (heading.classList.contains('part')) {
      if (!heading.id) heading.id = `parte-${toc.length + 1}`;
      toc.push({ id: heading.id, title, sections: [] });
      return;
    }

    sectionIndex += 1;
    if (!heading.id) heading.id = `secao-${sectionIndex}`;

    const currentPart = toc[toc.length - 1];
    if (currentPart) {
      currentPart.sections.push({ id: heading.id, title });
    } else {
      toc.push({ id: heading.id, title, sections: [] });
    }
  });

  return { html: sanitizeHtml(root.innerHTML), version, toc };
}
